








































































































import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { getDetail, getBaseInfo, getPrizeDetail } from '../api';
import { Toast } from 'vant';

Vue.use(Toast);

@Component({
  components: {
    XGplayer,
  },
})
export default class Detail extends Vue {
  detail: any = {};
  viewlist: any[] = [];
  baseInfo: any = {};
  get type() {
    return this.$route.query.type as string;
  }
  async mounted() {
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }
  async activated() {
    let ret: any;
    ret = await getDetail(this.$route.query.id as string);
    console.log(ret);
    this.detail = ret.data;
  }
  returnBack() {
    this.$router.go(-1);
  }
  onBack() {
    this.$router.back();
  }
  async onItemSwitch(id: string) {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
    });
    const ret = await getDetail(id);
    if (ret.data) {
      this.detail = ret.data;
    } else {
      Toast.fail({
        message: '没有数据了',
        duration: 0,
      });
      setTimeout(() => {
        Toast.clear();
      }, 2000);
    }
    // Toast.clear();
  }
}
